import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

import type { Step } from '../groupCreation';

import RetryCountdown from './RetryCountdown';

// Renders the per-step status list shared by the group-creation flows: an idle marker,
// a spinner while pending, and a success/error icon with the (optional) error message
// beneath the label.
export default function StepList({ steps }: { steps: Step[] }) {
  return (
    <ul className="space-y-2">
      {steps.map((step, i) => (
        <li key={i} className="flex items-start gap-2 text-sm">
          <span className="mt-0.5 shrink-0">
            {step.status === 'idle' && <span className="text-base-content/40">○</span>}
            {step.status === 'pending' && (
              <span className="loading loading-spinner loading-xs text-primary" />
            )}
            {step.status === 'success' && <CheckCircleIcon className="h-4 w-4 text-success" />}
            {step.status === 'error' && <ExclamationCircleIcon className="h-4 w-4 text-error" />}
          </span>
          <span>
            <span className={classNames({ 'text-error': step.status === 'error' })}>
              {step.label}
            </span>
            {step.error && <div className="text-error text-xs mt-0.5">{step.error}</div>}
            {step.status === 'pending' && step.retry && (
              // Re-key on attempt so each retry remounts the countdown (resets timer + bar).
              <RetryCountdown key={step.retry.attempt} {...step.retry} />
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}
